import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'ngc-recovery-code-login',
    templateUrl: './recovery-code-login.component.html',
    styleUrls: ['./recovery-code-login.component.scss']
})
export class RecoveryCodeLoginComponent implements OnInit, OnDestroy {

    @Input() loginForm: UntypedFormGroup;
    @Input() loginFormErrors: any;
    @Input() loading$: BehaviorSubject<boolean>;
    @Input() supportUrl: string;

    @Output() formSubmit = new EventEmitter<any>();
    @Output() backToMFALogIn = new EventEmitter<void>();

    private unsubscribe$ = new Subject<void>();

    constructor() { }

    ngOnInit(): void {
    }

    onFormSubmit(loginFormValue: any): void {
        this.formSubmit.emit(loginFormValue);
    }

    onBackToMFALogIn(): void {
        this.backToMFALogIn.emit();
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
